// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TRU6","left":"styles_left__3xWdZ","right":"styles_right__l52bp","alert":"styles_alert__1DCc8"};